import * as React from 'react';
import { Stack, Label, IconButton } from '@fluentui/react';

interface OnRenderRankLabelProps {
  onIconClick: () => void;
}

export const OnRenderRankLabel: React.FC<OnRenderRankLabelProps> = ({
  onIconClick,
}) => (
  <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}>
    <Label styles={{ root: { margin: 0 } }}>Rank</Label>
    <IconButton
      iconProps={{ iconName: 'AddTo' }}
      title="Add Rank"
      ariaLabel="Add Rank"
      onClick={onIconClick}
    />
  </Stack>
);
